module.exports = __webpack_public_path__ + "static/media/log-out-icon.d5a846dd.svg";